// @flow
import Links from './Links/Links';
import Mobile from '../LAFooter/Mobile/Mobile';
import React from 'react';
import styles from './WhiteLabelFooter.module.scss';

type Props = {
    mobileBrowserOS: string,
    whiteLabelName: string,
    windowWidth: number,
    year: number,
};

const WhiteLabelFooter = (props: Props) => {
    const { mobileBrowserOS, windowWidth, whiteLabelName, year } = props;

    return (
        <div className={styles.footer}>
            <Mobile mobileBrowserOS={mobileBrowserOS} windowWidth={windowWidth} />
            <Links whiteLabelName={whiteLabelName} year={year} />
        </div>
    );
};

export default React.memo<Props>(WhiteLabelFooter);
